<template>
    <div>
        <div class="show-navigation body--secondary" v-if="player">
            <div class="body--secondary__wrapper mb--md animated fadeIn">
                <header class="header">
                    <div class="container">
                        <div class="row align-items--center">
                            <div class="col-2">
                                <a @click.prevent="handleBack('/')" class="btn btn--icon btn--white">
                                    <i class="material-icons">keyboard_arrow_left</i>
                                </a>
                            </div>

                            <div class="col-8">
                                <h1 class="header__title">Profile</h1>
                            </div>
                        </div>
                    </div>
                </header>

                <section class="card card--expanded avatar-wrapper pb--30 mb--sm">
                    <div class="container">
                        <div class="profile profile--lg profile--vertical mb--30">
                            <figure class="profile__avatar mb--0">
                                <span class="profile__avatar__img">
                                   <img :src="player.avatar" />
                                </span>
                            </figure>

                            <div class="profile__text">
                                <div class="profile__name mb--0">{{ player.nick }}</div>
                                <div class="profile__level">
                                    <strong>Level {{ player.level }}</strong>
                                </div>
                            </div>
                        </div>

                        <ul class="counter counter--light mb--20">
                            <li>
                                <span class="counter__title">Games</span>
                                <div class="counter__number">{{ player.stats.total_games }}</div>
                            </li>
                            <li>
                                <span class="counter__title">Won</span>
                                <div class="counter__number">{{ player.stats.won }}</div>
                            </li>
                            <li>
                                <span class="counter__title">Won %</span>
                                <div class="counter__number">{{ player.stats.wonRate }}</div>
                            </li>
                        </ul>

                        <friend-button :user_id="player.id"></friend-button>
                    </div>
                </section>
            </div>

            <article class="card card--expanded mb--md" v-show="player.badges">
                <h2 class="title-primary text--center">Badges</h2>

                <div class="swiper-container iconbox-carousel mb--sm">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="badge in player.badges">
                            <div class="iconbox">
                                <img :src="badge.image" v-bind:alt="badge.name" />
                                <span>{{ badge.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </article>

            <article class="card card--expanded mb--md">
                <h2 class="title-primary text--center">Achievements</h2>

                <div class="swiper-container iconbox-carousel mb--sm">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" v-for="achievement in player.achievements">
                            <div class="iconbox">
                                <img :src="achievement.image" :alt="achievement.name" />
                                <span>{{ achievement.name }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </article>
        </div>
        <navigation></navigation>
    </div>
</template>

<script>
    import {mapGetters} from "vuex"
    import internalBackRoute from "../mixins/internalBackRoute";
    import Navigation from "./partial/Navigation";
    import FriendButton from "./partial/FriendButton";
    import api from "../api/users";
    import Swiper from "swiper";

    export default {
        name: "PublicProfile",
        components: {FriendButton, Navigation},
        mixins: [internalBackRoute],

        props: {
            id: {
                required: true
            }
        },

        data: function () {
            return {
                player: null,
                swiper: null,
            }
        },

        methods: {
            async getUser() {
                try {
                    let response = await api.show(this.id);

                    this.player = response.data;
                    this.createSwiper()
                } catch (error) {
                    if (error.response.status === 404) {
                        this.$router.push('/404')
                    }
                }
            },

            createSwiper() {
                if (! this.swiper) {
                    this.$nextTick(function () {
                        this.swiper = new Swiper('.iconbox-carousel', {
                            loop: true,
                            slidesPerView: 3,
                            centeredSlides: true,
                        })
                    })
                }
            }
        },

        computed: {
            ...mapGetters('auth', [
                'user',
            ]),
        },

        created() {
            this.getUser();
        }
    }
</script>